export default __webpack_public_path__ + "static/media/project1.d492e87a.jpg";